import { render, staticRenderFns, recyclableRender, components } from "./u-number-box.vue?vue&type=template&id=18418972&scoped=true&"
var renderjs
import script from "./u-number-box.vue?vue&type=script&lang=js&"
export * from "./u-number-box.vue?vue&type=script&lang=js&"
import style0 from "./u-number-box.vue?vue&type=style&index=0&id=18418972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18418972",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-number-box/u-number-box.vue"
export default component.exports